import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Loader2, ArrowLeft, Mail } from 'lucide-react';

function ForgotPasswordPage() {
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [email, setEmail] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await authAPI.forgotPassword(email);
            setSent(true);
            toast.success('Email envoyé !');
        } catch (err) {
            toast.error("Erreur lors de l'envoi");
        } finally {
            setLoading(false);
        }
    };

    if (sent) {
        return (
            <div className="text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Mail className="w-8 h-8 text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-foreground mb-2">Email envoyé !</h2>
                <p className="text-sm text-muted-foreground mb-6">
                    Si un compte existe avec l'adresse {email}, vous recevrez un lien de réinitialisation.
                </p>
                <Link to="/login">
                    <Button variant="outline" className="w-full" data-testid="back-to-login-button">
                        <ArrowLeft className="w-4 h-4 mr-2" />
                        Retour à la connexion
                    </Button>
                </Link>
            </div>
        );
    }

    return (
        <div>
            <h2 className="text-2xl font-bold text-foreground mb-2">Mot de passe oublié ?</h2>
            <p className="text-sm text-muted-foreground mb-6">
                Entrez votre email pour recevoir un lien de réinitialisation
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <Label htmlFor="email">Email</Label>
                    <Input
                        id="email"
                        type="email"
                        placeholder="votre@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        data-testid="forgot-email-input"
                    />
                </div>

                <Button 
                    type="submit" 
                    className="w-full" 
                    disabled={loading}
                    data-testid="forgot-submit-button"
                >
                    {loading ? (
                        <>
                            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                            Envoi en cours...
                        </>
                    ) : (
                        'Envoyer le lien'
                    )}
                </Button>
            </form>

            <div className="mt-6 text-center">
                <Link 
                    to="/login" 
                    className="text-sm text-primary font-medium hover:underline inline-flex items-center"
                    data-testid="back-link"
                >
                    <ArrowLeft className="w-4 h-4 mr-1" />
                    Retour à la connexion
                </Link>
            </div>
        </div>
    );
}

export default ForgotPasswordPage;
